module.exports = __webpack_public_path__ + "static/img/banner-csr-01.68a2b03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-01.jpg
// module id = itn7
// module chunks = 100